import { Box, Button, Text } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { useTransmitResolver } from '@bonanza-social/transmit-resolver';

function StatusTransmit() {
  const { handleTransmit } = useTransmitResolver();

  return (
    <Box alignItems="center" gap="space-400">
      <Text
        variant="h5"
        color="darkSurfacePrimary"
        textAlign="center"
        locNS="status"
        locKey="statusTransmitTitle"
      />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        textAlign="center"
        locNS="status"
        locKey="statusTransmitMessage"
      />
      <Button
        width="100%"
        locNS="status"
        locKey="statusInfoBannerButtonPlay"
        onPress={() => handleTransmit()}
      />
    </Box>
  );
}
export default memo(StatusTransmit);
